import { ValidationResult } from '../../../../../../../../../ui/gzForm/formField/types/form-validator';
import { translateFn } from '../../../../../../../../../utils/translator.helper';
import { ExchangeContentControlAttachmentFilteringRuleFormValue } from '../../../../../../utils/uiSettings/exchange/exchange-protection.types';
import { ExchangeContentControlAttachmentFilteringRule } from '@nirvana/shared/dtos/types/policies/common';

// validate duplicates
export function validateDuplicates(
  ruleItem: ExchangeContentControlAttachmentFilteringRuleFormValue,
  rulesInGrid: ExchangeContentControlAttachmentFilteringRule[]
): ValidationResult {
  const hasDuplicates = rulesInGrid.some(
    (ruleInGrid: ExchangeContentControlAttachmentFilteringRule) => ruleInGrid.name === ruleItem.name
  );

  if (hasDuplicates) {
    return {
      valid: false,
      error: translateFn('The entry already exists.'),
    };
  }

  return {
    valid: true,
  };
}
